(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('CategoryFranchiserListController', CategoryFranchiserListController)

    /** @ngInject */
    function CategoryFranchiserListController($httpParamSerializer, CategoryService, ROUTES, LoadingHelper, sweetAlert, UtilHelper, MeService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getCategories(start, number, tableState);
        }

        vm.configureReportDownload = () => {
            LoadingHelper.startLoading('.btn-download', true);
            vm.isLoadingDownloadData = true;

            const parameters = prepareParameters(0, 0, null);

            MeService
                .getDownloadToken()
                .then(success => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);

                    window.open(`${ROUTES.API}/category-report?Token=${success}&${$httpParamSerializer(parameters)}`, '_blank');
                }, error => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);
                    UtilHelper.errorCallback(error);
                })
        }

        vm.openMigrationModal = () => {
            vm.categoryOrigin = null;
            vm.categoryDestination = null;

            $('#category-migration').appendTo('body').modal('show');

            LoadingHelper.startLoading('.modal-loader');

            CategoryService
                .getAll()
                .then(success => {
                    vm.migrationCategories = success.Registers;
                    LoadingHelper.stopLoading('.modal-loader');
                }, error => {
                    vm.migrationCategories = null;

                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.modal-loader');
                })
        }

        vm.closeMigrationModal = () => {
            $('#category-migration').modal('hide');
        }

        vm.migrateRegisters = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Todas as empresas serão migradas para a nova categoria. Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.modal-loader');

                    CategoryService
                        .migrateData(vm.categoryOrigin.Id, vm.categoryDestination.Id)
                        .then(() => {
                            vm.closeMigrationModal();

                            UtilHelper.successCallback('migrate');
                            LoadingHelper.stopLoading('.modal-loader');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.modal-loader');
                        })
                }
            })
        }

        init();

        function getCategories(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            CategoryService
                .getByParameters(parameters)
                .then(success => {
                    vm.categories = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.categories = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: false
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'ExternalCode',
                Description: 'Código Externo'
            }, {
                Value: 'Name',
                Description: 'Título ou Descrição'
            }];
        }
    }
}());